/* eslint-disable */

export const getVisitDraftStorageKey = (localId) => {
  const parsed = Number(localId);
  return Number.isFinite(parsed) && parsed > 0 ? `bc:visitDraft:${parsed}` : null;
};

export const rememberVisitDraft = (localId, visitId, storage = sessionStorage) => {
  const key = getVisitDraftStorageKey(localId);
  const parsedVisitId = Number(visitId);
  if (!key || !Number.isFinite(parsedVisitId) || parsedVisitId <= 0) return false;
  try {
    storage.setItem(key, String(parsedVisitId));
    return true;
  } catch {
    return false;
  }
};

export const clearVisitDraft = (localId, storage = sessionStorage) => {
  const key = getVisitDraftStorageKey(localId);
  if (!key) return false;
  try {
    storage.removeItem(key);
    return true;
  } catch {
    return false;
  }
};

export const clearVisitDraftForTerminalResult = ({ localId, storage = sessionStorage } = {}) =>
  clearVisitDraft(localId, storage);

export const getVisitDraftTerminalDestination = ({
  outcome,
  localId,
  visitId,
  result = null,
} = {}) => {
  const parsedLocalId = Number(localId);
  const completedVisitId = Number(
    result?.visitWithCollection?.VisitId ??
    result?.visit?.Id ??
    result?.visitId ??
    visitId ??
    0
  );
  const hasLocal = Number.isFinite(parsedLocalId) && parsedLocalId > 0;

  if (outcome === "complete" || outcome === "alreadyComplete") {
    const path =
      hasLocal && Number.isFinite(completedVisitId) && completedVisitId > 0
        ? `/local/${parsedLocalId}/recaudaciones/${completedVisitId}`
        : Number.isFinite(completedVisitId) && completedVisitId > 0
        ? `/visit-details/${completedVisitId}`
        : hasLocal
        ? `/local/${parsedLocalId}`
        : "/local";
    return { kind: "detail", path };
  }

  return {
    kind: "local",
    path: hasLocal ? `/local/${parsedLocalId}` : "/local",
  };
};
